/**
 * EventBeleg entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';

export class EventBeleg extends BaseModel {
    defaults() {
        return {
            id: null,
            document_id: null,
            event_id: null,
            creator_id: null,
            given_name: null,
            created: null,

            // view fields
            path: null,
            type: null,
            size: null,
            name: null,
            readable_type: null,
            title: null,
            creator: null,
        };
    }

    mutations() {
        return {
            id: this.mutateId,
            created: dayjs,
            event_id: this.mutateId,
            creator_id: this.mutateId,
        };
    }

    mutateId(id: unknown) {
        const idNumber = Number(id);
        return idNumber > 0 ? idNumber : null;
    }
}

export class EventBelegCollection extends BaseCollection {
    options() {
        return {
            model: EventBeleg,
        };
    }
}

export function entityName() {
    return 'EventBeleg';
}
